<!--
卡

使用说明：

<CardItem
    :card="{Card}"
/>

Card={{
        'cardProtoCode':"fullnet-vir-net",
        'expireDate':"2019-10-23",
        'gainId':10004,
        'gainTime':"2018-10-23 17:01:51",
        'number':"RDMfullnetvirnet30x1221401333490611",
        'openTime':"1970-01-01 00:00:00",
        'opened':false,
        'secret':"",
        'skuImageUrl':"http://resource.uwan99.com/hk_data/a16f5c32-2840-4be1-9064-f937e8023cec",
        'skuName':"30M流量"
    }}

cardInfo = [{
  cardProtoCode:"fullnet-vir-net",
  expireDate:"2019-10-23",
  gainId:10004,
  gainTime:"2018-10-23 17:01:51",
  number:"RDMfullnetvirnet30x1221401333490611",
  openTime:"2018-10-24 13:40:45",
  opened:true,
  secret:"CY25SJfWLczALqxx",
  skuImageUrl:"http://resource.uwan99.com/hk_data/a16f5c32-2840-4be1-9064-f937e8023cec",
  skuName:"30M流量",
}]
-->
<template>
  <div class="card-wrap">
    <div class="list-item" :class="{ used: c.opened }">
      <!--卡信息:S-->
      <div class="item-title">
        <van-checkbox
          v-model="c.checked"
          style="margin-right: 2vw"
          v-if="showChecked"
          @change="handleChange(c)"
        ></van-checkbox>
        {{ c.skuName }}
      </div>
      <div class="item-sub-title">有效期：{{ c.expireDate }}</div>
      <div class="item-no">{{ c.number }}</div>
      <div class="dashed"></div>
      <div class="item-time">领用时间：{{ c.gainTime }}</div>
      <div class="item-open" v-if="!c.opened" @click="open(c)">刮开使用</div>
      <!--卡信息:E-->

      <!--卡操作:S-->

      <template v-if="c.opened">
        <Icon
          class="icon-charge"
          img="//res.uuudian.com/hk_data/cfc88f8a-1482-4b56-8223-79dc53b36e61"
        />
        <a class="btn-3" @click="secret(c.gainId)">查看卡密</a>
      </template>

      <!--卡操作:E-->

      <!-- 查看卡密  -->
      <van-popup v-model="isCardGet">
        <div class="m-header">
          <p>卡密领取</p>
          <img
            class="close"
            @click="closeModal"
            src="//res.uuudian.com/hk_data/1c90d459-3a56-4646-a43b-08296ea54f4d"
            alt
          />
        </div>
        <div class="content">
          <img
            src="//res.uuudian.com/hk_data/58fc3db6-5997-4049-b99a-950fa55c002d"
            alt
          />
          <div class="item">
            <p
              class="cardno J-cardno"
              :data-clipboard-text="cardInfo.number"
              @click="copy('.J-cardno')"
            >
              {{ cardInfo.number }}
            </p>
            <template v-if="cardInfo.cardProtoCode == 'yixiaofu'">
              <p class="tips">卡号</p>
            </template>
            <template v-else>
              <p class="tips">点击卡号直接复制</p>
            </template>
          </div>
          <div
            class="item"
            v-if="
              !(
                cardInfo.cardProtoCode &&
                cardInfo.cardProtoCode.startsWith('yixiaofu-')
              )
            "
          >
            <p
              class="cardno J-cardpwd"
              :data-clipboard-text="cardInfo.secret"
              @click="copy('.J-cardpwd')"
            >
              {{ cardInfo.secret }}
            </p>
            <template v-if="cardInfo.cardProtoCode == 'shangwang-jueyi'">
              <!-- 晌网提货 -->
              <p class="tips">点击提货码直接复制</p>
            </template>
            <template v-else>
              <p class="tips">点击密码直接复制</p>
            </template>
          </div>
          <div class="prize-wrap" v-if="count">
            <p>
              您有
              <span class="red">{{ count }}</span
              >碎片奖品待领取
            </p>
            <button class="get-btn" @click="gotoPrize">领取</button>
          </div>
        </div>
        <div class="m-btn-group">
          <template v-if="cardInfo.cardProtoCode == 'fullnet-vir-net'">
            <!-- 全网通虚拟流量 -->
            <span
              class="copy-all"
              :data-clipboard-text="allInfo"
              @click="copyAll"
              >全部复制</span
            >
            <span
              @click="
                ToCharge('/pages/orders/Charge?gainId=' + cardInfo.gainId)
              "
              >去充值</span
            >
          </template>
          <template v-if="cardInfo.cardProtoCode == 'shangwang-jueyi'">
            <!-- 晌网 -->
            <span
              class="copy-all"
              :data-clipboard-text="allInfo"
              @click="copyAll"
              >全部复制</span
            >
            <span @click="ToPickUp">去提货</span>
          </template>
          <template
            v-if="
              cardInfo.cardProtoCode &&
                cardInfo.cardProtoCode.startsWith('yixiaofu-')
            "
          >
            <!-- 易小付 -->
            <span @click="ToYixiaofuPickUp">去提卡密</span>
          </template>
        </div>
      </van-popup>
      <!-- 查看卡密  -->

      <!-- 提货 -->
      <div class="shangwang-dialog-ctn" :class="{ show: shangwangDialog.show }">
        <div class="shangwang-dialog">
          <div class="dialog-header">
            <div
              class="product-image"
              :style="{
                backgroundImage: 'url(' + shangwangDialog.currCard.icon + ')',
              }"
            ></div>
            <div class="product-name">{{ shangwangDialog.currCard.name }}</div>
            <button class="dialog-close" @click="hideShangwangDialog">
              close
            </button>
          </div>
          <!-- 编辑模式 -->
          <template v-if="shangwangDialog.mode == 'edit'">
            <div class="dialog-body">
              <div class="form">
                <div
                  class="sku-wrap"
                  v-show="shangwangDialog.skuList.length > 0"
                >
                  <div class="title">选择规格</div>
                  <div class="sku-list">
                    <div
                      class="sku-item"
                      :class="{ selected: sku.isSelected }"
                      v-for="sku in shangwangDialog.skuList"
                      :key="c.gainId + '-' + sku.id"
                      @click="selectShangwangSku(sku)"
                    >
                      {{ sku.title }}
                    </div>
                  </div>
                </div>
                <div class="xinput-wrap">
                  <div class="label">收货人</div>
                  <input
                    type="text"
                    placeholder="输入收货人名称"
                    v-model="shangwangDialog.receiverName"
                  />
                </div>
                <div class="xinput-wrap">
                  <div class="label">联系方式</div>
                  <input
                    type="number"
                    placeholder="输入手机号码"
                    v-model="shangwangDialog.receiverPhone"
                  />
                </div>
                <div class="xinput-wrap">
                  <div class="label">详细地址</div>
                  <input
                    type="text"
                    placeholder="省/市/区/街道/楼号"
                    v-model="shangwangDialog.receiverAddress"
                  />
                </div>
                <div class="tip">* 该产品不包邮</div>
              </div>
            </div>
            <div class="dialog-footer">
              <button @click="takeShangwang">确定提货</button>
            </div>
          </template>
          <!-- 展示模式 -->
          <template v-if="shangwangDialog.mode == 'show'">
            <div class="dialog-body">
              <div class="info-list">
                <ul>
                  <li>
                    <div class="left">
                      <p>供货商订单号</p>
                    </div>
                    <div class="right">
                      <p>{{ shangwangDialog.supplierOrderNo }}</p>
                    </div>
                  </li>
                  <li>
                    <div class="left">
                      <p>收件人</p>
                    </div>
                    <div class="right">
                      <p>{{ shangwangDialog.receiverName }}</p>
                    </div>
                  </li>
                  <li>
                    <div class="left">
                      <p>联系方式</p>
                    </div>
                    <div class="right">
                      <p>{{ shangwangDialog.receiverPhone }}</p>
                    </div>
                  </li>
                  <li>
                    <div class="left">
                      <p>收货地址</p>
                    </div>
                    <div class="right">
                      <p>{{ shangwangDialog.receiverAddress }}</p>
                    </div>
                  </li>
                  <li>
                    <div class="left">
                      <p>物流公司</p>
                    </div>
                    <div class="right">
                      <p>{{ shangwangDialog.logisticsCompany }}</p>
                    </div>
                  </li>
                  <li>
                    <div class="left">
                      <p>物流单号</p>
                    </div>
                    <div class="right">
                      <p>{{ shangwangDialog.logisticsOrderno }}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="dialog-footer">
              <template
                v-if="
                  shangwangDialog.logisticsCompany &&
                    shangwangDialog.logisticsOrderno
                "
              >
                <button
                  @click="viewLogistics(shangwangDialog.logisticsOrderno)"
                >
                  查看物流
                </button>
              </template>
              <template v-else>
                <button @click="hideShangwangDialog">关闭</button>
              </template>
            </div>
          </template>
        </div>

        <div class="mask" @click="hideShangwangDialog"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Decrypt } from "@/utils/des.js";
import CardGet from "@/components/orders/CardGet";
import CardSend from "@/components/orders/CardSend";
import Clipboard from "clipboard";
import { Dialog } from "vant";
import api from "../../api";

export default {
  props: ["card", "showChecked"],
  components: { CardGet, CardSend },
  data() {
    console.log("====ca222rd====");
    console.log(this.card);
    return {
      count: 0,
      c: this.card,
      isCardGet: false,
      // isCardSend: false,
      allInfo: "",
      cardInfo: {},
      shangwangDialog: {
        show: false,
        mode: "edit", //显示状态，edit编辑状态，show展示状态
        currCard: {
          name: this.card.skuName,
          // icon: 'https://wx4.sinaimg.cn/mw1024/e927d912gy1fv03yy7mhkj20rs0kuwl1.jpg'
          icon: this.card.skuImageUrl,
        },
        skuList: [],
        receiverName: "",
        receiverPhone: "",
        receiverAddress: "",
        supplierOrderNo: "",
        logisticsCompany: "",
        logisticsOrderno: "",
      },
    };
  },
  filters: {
    cardNoFormat(v) {
      return v.replace(/\s/g, "").replace(/(\w{4})(?=\w)/g, "$1 ");
    },
    timerFormat(v) {
      var date = new Date(v);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? "0" + minute : minute;
      second = second < 10 ? "0" + second : second;
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
    },
  },
  methods: {
    gotoPrize() {
      var url = process.env.lotteryLoginUrl;
      location.href = url;
    },
    displayCard(c) {
      console.log(c);
    },
    closeModal() {
      this.isCardGet = false;
    },
    open(card) {
      //获取用户是否需要验证手机，防止疯狂兑换
      api.user.getPhoneValidSetting(res => {
        if (
          res.enabled && //已开启手机绑定
          !res.binding && //未绑定手机号
          res.vmallCostCent >= res.vmallCostCentThreshold //需要绑定手机的阈值 >= 用户兑换虚拟卡总金额
        ) {
          this.$emit("phone");
          return;
        } else {
          if (this.showChecked) {
            return;
          }
          console.log(card);
          var gainId = card.gainId;
          Dialog.confirm({
            className: "m-comfirm",
            title: "刮开卡密",
            message: "是否确认刮开卡密？",
            confirmButtonText: "确认刮开",
            cancelButtonText: "取消刮开",
          })
            .then(() => {
              // on confirm
              api.wallet.open(
                gainId,
                data => {
                  this.c.opened = true;
                  this.secret(gainId);
                },
                r => {
                  this.$alertDialog(r.msg);
                }
              );
            })
            .catch(() => {
              // on cancel
            });
        }
      });
    },
    secret(gainId) {
      if (this.showChecked) {
        return;
      }
      this.$showLoading("加载中...");
      api.wallet.secret(
        gainId,
        data => {
          if (data.cardInfo.encryptSecret) {
            let inkey = this.Store.loginedUser.sec;
            let insecret = Decrypt(data.cardInfo.encryptSecret, inkey);
            this.cardInfo = data.cardInfo;
            Object.assign(this.cardInfo, { secret: insecret });
          } else {
            this.cardInfo = data.cardInfo;
          }
          this.$hideLoading();
          this.isCardGet = true;
        },
        r => {
          this.$hideLoading();
          this.$alertDialog(r.msg);
        }
      );

      this.getPrizeCount();
    },
    getPrizeCount() {
      var count = 0;
      api.lottery.getPrizeCount(res => {
        if (res.exchangePresentShredActivity.opened) {
          if (res.exchangePresentShredActivity.activated) {
            if (!res.exchangePresentShredActivity.claimed) {
              if (res.exchangePresentShredActivity.shredCount) {
                count += res.exchangePresentShredActivity.shredCount;
              }
            }
          }
        }

        if (res.lotteryPresentShredActivity.opened) {
          if (res.lotteryPresentShredActivity.activated) {
            if (!res.lotteryPresentShredActivity.claimed) {
              if (res.lotteryPresentShredActivity.shredCount) {
                count += res.lotteryPresentShredActivity.shredCount;
              }
            }
          }
        }

        this.count = count;
      });
    },
    copy(el) {
      if (
        this.cardInfo.cardProtoCode &&
        this.cardInfo.cardProtoCode.startsWith("yixiaofu-")
      ) {
        //skip copy
        return;
      }
      var clipboard = new Clipboard(el);
      clipboard.on("success", e => {
        this.$toast("复制成功");
        // 释放内存
        clipboard.destroy();
      });
    },
    copyAll() {
      var clipboard = new Clipboard(".copy-all");
      var info =
        "卡号：" +
        this.cardInfo.number +
        " / " +
        "密码：" +
        this.cardInfo.secret;
      this.allInfo = info;
      clipboard.on("success", e => {
        this.$toast("复制成功");
        // 释放内存
        clipboard.destroy();
      });
    },
    ToCharge(link) {
      // alert('去充值')
      this.$routerPush(this, link);
    },
    ToPickUp() {
      // alert('去提货')
      this.$showLoading("加载中...");
      this.isCardGet = false;

      //获取提货状态
      api.wallet.pickUpStatus(
        this.c.gainId,
        pickUpStatus => {
          if (pickUpStatus.picked) {
            //已经提货，显示提货状态
            this.$hideLoading();
            this.shangwangDialog.mode = "show";
            this.shangwangDialog.show = true;
            this.shangwangDialog.receiverName = pickUpStatus.receiverName;
            this.shangwangDialog.receiverAddress = pickUpStatus.receiverAddress;
            this.shangwangDialog.receiverPhone = pickUpStatus.receiverPhone;

            this.shangwangDialog.supplierOrderNo = pickUpStatus.supplierOrderno;
            this.shangwangDialog.logisticsCompany =
              pickUpStatus.logisticsCompany;
            this.shangwangDialog.logisticsOrderno =
              pickUpStatus.logisticsOrderno;
          } else {
            //已经提货，显示提货状态
            api.wallet.shangwangSkuList(
              this.c.gainId,
              d => {
                this.shangwangDialog.skuList = [];
                if (d.shangwangSkus && d.shangwangSkus.length > 0) {
                  //规格列表
                  var isSelected = false;
                  d.shangwangSkus.forEach(it => {
                    this.shangwangDialog.skuList.push({
                      id: it.id,
                      title: it.title,
                      isSelected: isSelected ? false : true, //选择第一个规格
                    });
                    isSelected = true;
                  });
                }
                this.$hideLoading();
                this.shangwangDialog.show = true;
              },
              r => {
                this.$hideLoading();
                this.$alertDialog(r.msg);
              }
            );
          }
        },
        r => {
          this.$hideLoading();
          this.$alertDialog(r.msg);
        }
      );
    },
    ToYixiaofuPickUp() {
      this.$routerPush(
        this,
        `/pages/orders/YixiaofuCharge?gainId=${this.card.gainId}`
      );
    },
    hideShangwangDialog() {
      this.shangwangDialog.show = false;
    },
    selectShangwangSku(sku) {
      this.shangwangDialog.skuList.forEach(it => {
        it.isSelected = false;
      });
      sku.isSelected = true;
    },
    takeShangwang() {
      //检查参数

      //提示确定
      Dialog.confirm({
        className: "m-comfirm",
        title: "提示",
        message: "确定提货吗？",
        confirmButtonText: "确认提货",
        cancelButtonText: "取消",
      })
        .then(() => {
          // on confirm
          var selectedSku = null;
          var skuId = 0;
          this.shangwangDialog.skuList.forEach(it => {
            if (it.isSelected) {
              selectedSku = it;
            }
          });
          if (selectedSku) {
            skuId = selectedSku.id;
          }

          this.$showLoading("提货中...");
          api.wallet.pickUp(
            this.c.gainId,
            this.shangwangDialog.receiverAddress,
            this.shangwangDialog.receiverName,
            this.shangwangDialog.receiverPhone,
            skuId,
            data => {
              this.$toast("已提货");
              this.$hideLoading();
              this.shangwangDialog.show = false;
            },
            r => {
              this.$hideLoading();
              this.$alertDialog(r.msg);
            }
          );
        })
        .catch(() => {
          // on cancel
        });
    },
    viewLogistics(orderno) {
      //前往快递100查看快递信息
      location.href =
        "https://m.kuaidi100.com/index_all.html?postid=" + orderno;
    },
    handleChange(c) {
      console.log(c);
      if (!c.opened) {
        c.checked = false;
        this.$toast("不可删除未使用卡密");
      }
    },
  },
};
</script>

<style lang="less">
@activeColor: #ff7e5f;
@diactiveColor: #c7c7c7;

.prize-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #ddd;
  .red {
    color: #ff0000;
  }
  .get-btn {
    border: 0;
    outline: none;
    background: linear-gradient(to right, #ff0000, #ff7152);
    color: #fff;
    border-radius: 25px;
    font-size: 14px;
    padding: 1vw 3vw;
  }
}

.ivu-modal-footer {
  padding: 0;
}
.card-wrap {
  border: none;
  .list-item {
    display: block;
    width: 94.26vw;
    min-height: 38vw;
    margin: 0 auto 4.2666vw;
    border-radius: 1.333vw;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    box-sizing: border-box;
    padding-top: 4vw;
    padding-left: 6vw;
    position: relative;
    -moz-box-shadow: 5px 5px 6px #d6d5db;
    -webkit-box-shadow: 5px 5px 6px #d6d5db;
    box-shadow: 5px 5px 6px #d6d5db;
    background-image: linear-gradient(to right, #ff0028, #ff805f);

    .item-title {
      color: white;
      font-size: 4.53vw;
      font-weight: normal;
      margin-bottom: 1vw;
      max-width: 14em;
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; //溢出不换行
      display: flex;
      align-items: center;
    }

    .item-sub-title {
      color: white;
      font-size: 3.4vw;
      margin-bottom: 4vw;
    }

    .item-no {
      color: @activeColor;
      font-size: 3.8vw;
      margin-bottom: 3.7333vw;
    }

    .dashed {
      height: 0.266vw;
      background: linear-gradient(
        to right,
        @activeColor,
        @activeColor 5px,
        transparent 5px,
        transparent
      );
      background-size: 10px 100%;
      width: 84.666vw;
      margin-bottom: 2vw;
    }

    .item-time {
      color: @activeColor;
      font-size: 3.4vw;
      //opacity: .6;
      margin-bottom: 1vw;
    }

    .item-open {
      position: absolute;
      right: 3.7333vw;
      top: 7.333vw;
      background: linear-gradient(to right, #907c7b, #b3b3b3);
      color: #fff;
      padding: 2vw 3vw;
      font-size: 3vw;
      border-radius: 15px;
    }

    .btn-1,
    .btn-2,
    .btn-3 {
      text-align: center;
      color: white;
    }

    &.used {
      background-image: none;
      background-color: #fff;
      border: 1px solid #ccc;

      .item-title {
        color: @diactiveColor;
      }

      .item-sub-title {
        color: @diactiveColor;
      }

      .item-no {
        color: @diactiveColor;
      }

      .dashed {
        background: linear-gradient(
          to right,
          @diactiveColor,
          @diactiveColor 5px,
          transparent 5px,
          transparent
        );
        background-size: 10px 100%;
      }
      .item-time {
        color: @diactiveColor;
      }

      .btn-3 {
        color: @themeColor;
        border-color: @diactiveColor;
      }
    }
  }

  .btn-1 {
    border-radius: 3.8vw;
    border: none;
    width: 14.4vw;
    line-height: 7.466vw;
    background: #ffa044;
    position: absolute;
    right: 3.733vw;
    top: 3.2vw;
    font-size: 3.46vw;
  }

  .btn-2,
  .btn-3 {
    position: absolute;
    right: 0vw;
    bottom: 1.8666vw;
    background: transparent;
    font-size: 3.2vw;
    width: 21.866vw;
    height: 4.8vw;
    line-height: 4.8vw;
    border: none;
    border-left: 0.266vw solid @activeColor;
  }

  .list-item .icon-gain,
  .list-item .icon-used,
  .list-item .icon-charge {
    background-repeat: no-repeat;
    background-position: top right;
    background-size: contain;
    position: absolute;
    top: 3.2vw;
    right: 0;
    width: 19.7vw;
    height: 19.7vw;
  }

  .list-item .icon.icon-gain {
    background-image: url(//res.uuudian.com/hk_data/8cd6f52e-6369-4f82-8beb-64168a0239da);
  }

  .list-item .icon.icon-used {
    background-image: url(//res.uuudian.com/hk_data/0e8f7320-c9b9-48ee-a85f-1212848c3b70);
  }

  .list-item .icon.icon-charge {
    background-image: url(//resource.uwan99.com/hk_data/9b8ab089-7551-4f17-969f-229da80c2f5c);
  }
}

.m-comfirm {
  .van-dialog__content {
    text-align: center;
    padding: 4vw 0;
  }
  .van-dialog__confirm {
    background: linear-gradient(to right, #fe0229, #fe7d5d);
    color: #fff;
  }
}

.content {
  padding: 4vw;
  img {
    width: 100%;
    margin-bottom: 2vw;
  }

  .item {
    margin-bottom: 5vw;
    padding: 0 3vw;
  }

  .cardno {
    font-size: 3.8vw;
    color: #333;
    margin-bottom: 1vw;
  }
  .tips {
    color: #999;
    font-size: 3vw;
  }
}
.m-header {
  p {
    margin: 0;
    text-align: center;
    padding: 6vw;
    border-bottom: 1px solid #e5e5e5;
  }
}

.m-btn-group {
  display: flex;
  justify-content: center;
  border-top: 1px solid #e5e5e5;

  span {
    flex: 1;
    text-align: center;
    padding: 4vw 0;
    font-size: 4vw;
  }
  span:first-child {
    border-right: 1px solid #e5e5e5;
  }
  span:last-child {
    background: linear-gradient(to right, #fe0229, #fe7d5d);
    color: #fff;
    border-bottom-right-radius: 5px;
  }
}

.close {
  position: absolute;
  width: 3vw;
  top: 7vw;
  right: 6vw;
}

/*shangwang-dialog-ctn*/
.shangwang-dialog-ctn {
  display: none;
}

.shangwang-dialog-ctn.show {
  display: block;
}

.shangwang-dialog-ctn .mask {
  z-index: 11;
  background: #000;
  opacity: 0.6;
}

.shangwang-dialog-ctn {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.shangwang-dialog {
  position: absolute;
  z-index: 1000;
  top: 5vh;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
}

.shangwang-dialog .dialog-header {
  height: 32vw;
  position: relative;
}

.shangwang-dialog .dialog-header:after {
  content: "";
  background-image: url(//res.uuudian.com/hk_data/0d8cdb5b-9f0a-485b-99c4-5a7c60c6fa25);
  background-position: center;
  background-size: cover;
  position: absolute;
  height: 1.5vw;
  width: 100vw;
  bottom: 0vw;
}

.shangwang-dialog .product-image {
  width: 28.666vw;
  height: 28.666vw;
  border: 0.53vw solid #fff;
  outline: 0.266vw solid #6c7177;
  position: absolute;
  left: 4.3vw;
  top: -4vw;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
}

.shangwang-dialog .dialog-close {
  width: 2.8vw;
  height: 2.8vw;
  position: absolute;
  z-index: 13;
  top: 4.9vw;
  right: 4vw;
  display: block;
  margin: 0 auto;
  background-color: transparent;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: contain;
  background-image: url("//res.uuudian.com/hk_data/79f79d60-0a49-4321-8eff-5799574d8a1d");
  font-size: 0;
  border: none;
}

.shangwang-dialog .product-name {
  position: absolute;
  z-index: 13;
  left: 38.4vw;
  top: 4.9vw;
  width: 48vw;
  font-size: 3.46vw;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-height: 1.5em;
  height: 3em;
}

.shangwang-dialog .dialog-footer {
  position: fixed;
  z-index: 1002;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  height: 16.53vw;
}

.shangwang-dialog button {
  background-image: linear-gradient(90deg, #ff0d33, #ff7f5f);
  color: #fff;
  height: 12vw;
  width: 92vw;
  line-height: 12vw;
  font-size: 4.26vw;
  border: none;
  display: block;
  margin: 2.53vw auto;
  border-radius: 6vw;
}

body.input {
  max-height: 100vh;
  overflow: hidden;
}

body.input .shangwang-dialog {
  top: -30vw;
}

body.input .dialog-footer {
  height: 10.53vw;
}

body.input .shangwang-dialog button {
  height: 8vw;
  line-height: 8vw;
  font-size: 3.4vw;
  margin: 1vw auto;
}

/*表单*/
.form {
  padding: 4vw;
}

.form .xinput-wrap {
  font-size: 3.733vw;
  line-height: 12.66vw;
  text-align: left;
  border-bottom: 1px solid #ccc;
}

.form .xinput-wrap .label {
  display: inline-block;
  color: #333;
  width: 25.666vw;
}

.form .xinput-wrap input {
  background: transparent;
  display: inline-block;
  width: 57vw;
  line-height: 12.66vw;
  font-size: 3.733vw;
  border: 0;
  -webkit-appearance: none;
}

.form .tip {
  font-size: 3.733vw;
  line-height: 12.66vw;
  color: #999;
}

.form .sku-wrap {
  color: #333;
  padding-bottom: 2.6vw;
}

.form .sku-wrap .title {
  font-size: 3.6vw;
  padding-left: 0vw;
  line-height: 10.93vw;
}

.form .sku-wrap .sku-list {
  padding: 0 3vw;
}

.form .sku-wrap .sku-list .sku-item {
  display: inline-block;
  margin: 1.06vw;
  font-size: 3.06vw;
  background: #e5e5e5;
  line-height: 7.73vw;
  border-radius: 3.865vw;
  text-align: center;
  padding: 0 3.73vw;
}

.form .sku-wrap .sku-list .sku-item.selected {
  color: #fff;
  background: #f93;
}

/*信息列表*/

.info-list {
  background: #fff;
  margin-top: 4vw;
}

.info-list ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.info-list p {
  margin: 0;
}

.info-list ul li {
  padding: 4vw 0;
  font-size: 3.466666vw;
  margin: 0 4vw;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: justify;
  justify-content: space-between;
  border-bottom: 1px solid #e6e6e6;
}

.info-list .left {
  width: 6em;
}

.info-list .right {
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/orders/CardItem.vue